import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=060a4f01&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=060a4f01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a4f01",
  null
  
)

export default component.exports